import {useAppDispatch, useWarrantyId} from "../redux/stateHooks";
import {setWarranty} from "../redux/slices/addToCart";

export const useWarrantyChange = () => {
    const dispatch = useAppDispatch();
    const warrantyId = useWarrantyId();
    return {
        activeWarrantyId: warrantyId,
        onChange: (id: number) => dispatch(setWarranty(warrantyId === id ? undefined : id))
    }
}